import CryptoJS from "crypto-js";

const secretKey = "Xy9kM2lKcW1UeF9zVGZhb0RzYjEyMzQ1Njc4OQ==";

export function encryptId(id) {
  const cipher = CryptoJS.AES.encrypt(String(id), secretKey).toString();
  return encodeURIComponent(cipher);
}

export function decryptId(ciphertext) {
  const decoded = decodeURIComponent(ciphertext);
  const bytes = CryptoJS.AES.decrypt(decoded, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
}
